/**
 * Utilitários para links de conversa no WhatsApp.
 */

export function digitsOnly(value: string): string {
  return value.replace(/\D/g, '')
}

/** Dígitos no formato internacional esperado pelo wa.me (sem símbolos, sem +). */
export function phoneDigitsForWhatsApp(phone: string): string | null {
  const digits = digitsOnly(phone)
  if (digits.length < 10) return null
  if (digits.startsWith('55') && digits.length >= 12) return digits
  if (digits.length === 10 || digits.length === 11) return `55${digits}`
  return digits.length >= 12 ? digits : null
}

export function buildWhatsAppChatHref(phone: string, message?: string): string | null {
  const waDigits = phoneDigitsForWhatsApp(phone)
  if (!waDigits) return null

  const trimmedMessage = message?.trim()
  if (trimmedMessage) {
    return `https://wa.me/${waDigits}?text=${encodeURIComponent(trimmedMessage)}`
  }

  return `https://wa.me/${waDigits}`
}
